import { z } from 'zod'
import { addressSchema } from '../../shared/address-schema'

const nameSchema = z.object({
  first_name: z
    .string()
    .nullish()
    .transform((x) => x ?? undefined),
  last_name: z
    .string()
    .nullish()
    .transform((x) => x ?? undefined),
})

export type NameTypes = z.infer<typeof nameSchema>

const phoneSchema = z.object({
  phone_number: z
    .string()
    .nullish()
    .transform((x) => x ?? undefined),
})

export type PhoneTypes = z.infer<typeof phoneSchema>

const birthDateSchema = z.object({
  birthdate: z
    .string()
    .nullish()
    .transform((x) => x ?? undefined),
})

export type BirthDateTypes = z.infer<typeof birthDateSchema>

export const profileDataSchema = z
  .object({
    uuid: z.string().uuid(),
    drupal_id: z.number().int().nullish(),
    has_approved_investments: z.boolean(),
    address: addressSchema.nullish().transform((x) => x ?? undefined),
  })
  .merge(nameSchema)
  .merge(phoneSchema)
  .merge(birthDateSchema)

export type ProfileDataTypes = z.infer<typeof profileDataSchema>

export const commPrefsSchema = z.object({
  sms_opt_in: z.boolean(),
})

export type CommPrefsTypes = z.infer<typeof commPrefsSchema>

const nullableArray = z
  .array(z.string())
  .nullish()
  .transform((x) => x ?? [])
const nullableString = z
  .string()
  .nullish()
  .transform((x) => x ?? '')
const nullableInteger = z
  .union([
    z.number().int().nonnegative(),
    z
      .string()
      .regex(/^\d+$/)
      .transform((value) => Number.parseInt(value, 10)),
  ])
  .nullish()
  .transform((x) => x ?? undefined)

export const gtkyRequestSchema = z.object({
  id: z
    .number()
    .int()
    .nullish()
    .transform((x) => x ?? undefined),
  risk: nullableArray,
  holdPeriod: nullableArray,
  currentInvestments: nullableArray,
  propertyTypes: nullableArray,
  need1031: z
    .boolean()
    .nullish()
    .transform((x) => x ?? undefined),
  employmentType: nullableString,
  employer: nullableString,
  employmentPositionHeld: nullableString,
  employmentIndustry: nullableString,
  sourceOfIncome: nullableString,
  sourceOfWealth: nullableString,
  specificIncome: nullableInteger,
  specificNetWorth: nullableInteger,
  draft: z
    .boolean()
    .nullish()
    .transform((x) => x ?? false),
})

export type GTKYRequestTypes = z.infer<typeof gtkyRequestSchema>

export const gtkyResponseSchema = z.object({
  redirect: z
    .string()
    .nullish()
    .transform((x) => x ?? undefined),
  complete: z.boolean(),
  request: gtkyRequestSchema.nullish().transform((x) => x ?? undefined),
})

export type GTKYResponseTypes = z.infer<typeof gtkyResponseSchema>
